import { render, staticRenderFns } from "./AlertErrorMessagesComponent.vue?vue&type=template&id=68263687&scoped=true&"
import script from "./AlertErrorMessagesComponent.vue?vue&type=script&lang=js&"
export * from "./AlertErrorMessagesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68263687",
  null
  
)

export default component.exports